export type PreviousDiscountRaw = boolean | number | string | null | undefined;

export interface ClinicLocationDto {
  id: number;
  clinic_id: number;
  address: string;
  address2: string | null;
  city: string;
  state: string;
  zip_code: string;
  phone: string;
  email_address: string;
  active: number | boolean;
  end_date?: string | null;
}

export interface ClinicAdminDto {
  id: number;
  clinic_id: number;
  first_name: string;
  last_name: string;
  email_address: string;
  phone: string;
  active: boolean | number;
  end_date: string | null;
}

export interface ClinicDemographicsApiResponse {
  id: number;
  clinic_name: string;
  clinic_website: string | null;
  npi: string;
  provider_npi: string;
  active: boolean | number | string;
  previous_plan?: string | null;
  previous_discount?: PreviousDiscountRaw;
  previous_discount_name?: string | null;
  locations?: ClinicLocationDto[];
  admins?: ClinicAdminDto[];
  created_at?: string;
  updated_at?: string;
}

export interface ClinicDemographicsState {
  id: number;
  clinic_name: string;
  clinic_website: string;
  npi: string;
  provider_npi: string;
  active: boolean;
  previous_discount: boolean | null;
  previous_discount_name: string | null;
  created_at: string;
}

export interface SaveClinicDemographicsDto {
  clinic_npi: string;
  individual_npi: string;
  clinic_website: string;
  previous_discount: boolean;
  previous_discount_name: string | null;
}

export function normalizeBoolean(value: PreviousDiscountRaw): boolean | null {
  if (value === true || value === 1 || value === '1' || value === 'true') {
    return true;
  }

  if (value === false || value === 0 || value === '0' || value === 'false') {
    return false;
  }

  return null;
}

export function mapClinicDemographicsApiToState(
  demographics: ClinicDemographicsApiResponse
): ClinicDemographicsState {
  return {
    id: demographics.id ?? 0,
    clinic_name: demographics.clinic_name ?? '',
    clinic_website: demographics.clinic_website ?? '',
    npi: demographics.npi ?? '',
    provider_npi: demographics.provider_npi ?? '',
    active: normalizeBoolean(demographics.active) ?? false,
    previous_discount: normalizeBoolean(demographics.previous_discount),
    previous_discount_name: demographics.previous_discount_name ?? null,
    created_at: demographics.created_at ?? ''
  };
}